export const PersonaTemplateIDs = {
  GOVERNMENT_ID_AND_SELFIE: "itmpl_harVuEE5mHY31d29vRuZrsXwjXM3",
  I9_GOVERNMENT_ID_OR_DOCUMENT: "itmpl_CFQ8Aq7R236XQhmySCCBPLcmfgcX",
  SSN_VERIFICATION: "itmpl_NnTKxgKormmMuouymRvm1tmtaZbN",
  GOVERNMENT_ID: "itmpl_bRHmkTB4JoLBjkFRu1dLzAT2FZcX",
} as const;
